module.exports = __webpack_public_path__ + "static/media/IMG-13.0978c29c.jpg";